import { render, staticRenderFns } from "./ms-history-check.vue?vue&type=template&id=5b3415ac&scoped=true"
import script from "./ms-history-check.vue?vue&type=script&lang=js"
export * from "./ms-history-check.vue?vue&type=script&lang=js"
import style0 from "./ms-history-check.vue?vue&type=style&index=0&id=5b3415ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3415ac",
  null
  
)

export default component.exports